import { Box, Flex, Text } from '@chakra-ui/react';

import { UserCreditSelectListContainer } from '~/components/common/credits/UserCreditSelectListContainer';
import { useI18nLn } from '~/hooks/store';
import { PaymentMethod } from '~/lib/payment';
import { PaymentMethodVariables } from '~/types/payment';
import { GmoCredit } from '~/types/resources/gmo_credit';
import { CarriersPaymentForm } from '../orders/form/CarriersPaymentForm';

type Props = {
  payment_methods: PaymentMethod[];
  payment_method: PaymentMethodVariables | null;
  setPaymentMethod: (payment_method: PaymentMethodVariables) => void;
  setCardSeq: (cardSeq: string | null) => void;
  credits: GmoCredit[];
  loading: boolean;
  mutate: () => void;
};

export const SelectPaymentDetail: React.FC<Props> = (props: Props) => {
  const { t } = useI18nLn();

  if (props.payment_method?.startsWith('carriers')) {
    return (
      <Flex flexDir="column">
        <Text fontSize="16px" fontWeight="bold">
          {t('pages.buy.payments.carrier.title')}
        </Text>
        <Box h="16px" />
        <Flex px={2}>
          <CarriersPaymentForm
            payment_methods={props.payment_methods}
            selectedMethod={props.payment_method}
            onSelect={props.setPaymentMethod}
          />
        </Flex>
      </Flex>
    );
  }

  switch (props.payment_method) {
    case 'credit':
      return (
        <Flex flexDir="column" gap={3}>
          <Text fontSize="16px" fontWeight="bold">
            {t('pages.buy.payments.credit.title')}
          </Text>
          <UserCreditSelectListContainer
            setCardSeq={props.setCardSeq}
            credits={props.credits}
            loading={props.loading}
            mutate={props.mutate}
          />
          <Flex flexDir="column" align="center" w="full">
            <Text fontSize="15px" whiteSpace="pre-line">
              {t('pages.buy.payments.purchase_detail_description.credit')}
            </Text>
          </Flex>
        </Flex>
      );
    case 'paypay':
      return (
        <Flex flexDir="column" align="center" w="full">
          <Text fontSize="15px" whiteSpace="pre-line">
            {t('pages.buy.payments.purchase_detail_description.app')}
          </Text>
        </Flex>
      );
    case 'unionpay':
      return (
        <Flex flexDir="column" align="center" w="full">
          <Text fontSize="15px" whiteSpace="pre-line">
            {t('pages.buy.payments.purchase_detail_description.credit')}
          </Text>
        </Flex>
      );
    case 'alipay+':
      return (
        <Flex flexDir="column" align="center" w="full">
          <Text fontSize="15px" whiteSpace="pre-line">
            {t('pages.buy.payments.purchase_detail_description.credit')}
          </Text>
        </Flex>
      );
    case 'applepay':
      return (
        <Flex flexDir="column" align="center" w="full">
          <Text fontSize="15px" whiteSpace="pre-line">
            {t('pages.buy.payments.purchase_detail_description.credit')}
          </Text>
        </Flex>
      );
    default:
      return null;
  }
};
